'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MediaRight = require('react-bootstrap/lib/MediaRight');

var _MediaRight2 = _interopRequireDefault(_MediaRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MediaRight2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/MediaRight.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/MediaRight.js
 ** module chunks = 0
 **/